import { Controller, useFormContext } from "react-hook-form";
import {
  MenuItem,
  Checkbox,
  ListItemText,
  FormHelperText,
  Box,
  Select,
  InputLabel,
} from "@mui/material";
import { StyledFormControl } from "./StyleInputs";
import { KeyboardArrowDown } from "@mui/icons-material";

const MultiSelectField = ({ field }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const errorMessage = errors[field.id]?.message;

  return (
    <Box sx={{ mb: 3 }}>
      <Controller
        name={field.id}
        control={control}
        defaultValue={[]}
        rules={{
          required: field.required ? `${field.label} is required` : false,
        }}
        render={({ field: { onChange, value = [], ref } }) => (
          <StyledFormControl fullWidth error={!!errorMessage}>
            <InputLabel
              sx={{ fontWeight: 500, color: "text.primary" }}
              required={Boolean(field.required)}
            >
              {field.label}
            </InputLabel>
            <Select
              multiple
              value={value}
              onChange={onChange}
              inputRef={ref}
              label={field.label}
              required={field.required}
              IconComponent={KeyboardArrowDown}
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return (
                    <em style={{ fontStyle: "normal" }}>{field.placeholder}</em>
                  );
                }
                const selectedLabels = field.options
                  ?.filter((option) => selected.includes(option.value))
                  .map((option) => option.label);
                return selectedLabels?.join(", ");
              }}
            >
              {field.options?.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <Checkbox checked={value.includes(option.value)} />
                  <ListItemText primary={option.label} />
                </MenuItem>
              ))}
            </Select>
            {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
          </StyledFormControl>
        )}
      />
    </Box>
  );
};

export default MultiSelectField;
